
import React, { useState } from "react";
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { T } from "./Translate";
import translateService from "../services/translateService";
import PageHeader from "./PageHeader";
import { pageContentSx } from "../pageLayout";
import { languages } from "./languages";

const Language = () => {
  const [selected, setSelected] = useState(
    translateService.isAutoLanguage() ? 'auto' : translateService.getLanguage() || 'es'
  );

  const handleSelect = (langCode) => {
    setSelected(langCode);
    translateService.setLanguage(langCode);
    window.location.reload();
  };

  const handleSelectAuto = () => {
    setSelected('auto');
    translateService.setAutoLanguage().finally(() => window.location.reload());
  };

  return (
    <Box>
      <PageHeader title={<T>Idioma</T>} />
      <Box sx={pageContentSx}>
        <List>
          <ListItem disablePadding>
            <ListItemButton selected={selected === 'auto'} onClick={handleSelectAuto}>
              <ListItemIcon>
                <span style={{ fontSize: 22 }}>🌐</span>
              </ListItemIcon>
              <ListItemText
                primary={<T>Automático</T>}
                secondary={<T>Según tu ubicación</T>}
              />
            </ListItemButton>
          </ListItem>
          {languages.map((lang) => (
            <ListItem key={lang.code} disablePadding>
              <ListItemButton selected={selected === lang.code} onClick={() => handleSelect(lang.code)}>
                <ListItemIcon>
                  <span style={{ fontSize: 22 }}>{lang.flag}</span>
                </ListItemIcon>
                <ListItemText primary={<>{lang.code.toUpperCase()} {lang.name}</>} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default Language;
